import {Navigate} from 'react-router-dom';
import type {RouteObject} from 'react-router-dom';

import {useDeviceContext} from '@/providers/DeviceContext';
import {useResponsiveContext} from '@/providers/ResponsiveContext';

import adminRoutes from './admin/admin.routes';
import loginRoutes from './login.routes';
import mobileBoardRoutes from './mobile/board.routes';
import mobileRoutes from './mobile/map.routes';
import mobilePortalRoutes from './mobile/portal.routes';
import authRoutes from './pc/auth.routes';
import boardRoutes from './pc/board.routes';
import pcRoutes from './pc/map.routes';
import portalRoutes from './pc/portal.routes';

export const useAppRoutes = (): RouteObject[] => {
  const {isPC} = useResponsiveContext();

  const routes: RouteObject[] = [
    {
      path: '/',
      element: <Navigate to="/portal" replace />
    },
    ...(isPC ? pcRoutes : mobileRoutes),
    ...adminRoutes,
    ...loginRoutes,
    ...(isPC ? portalRoutes : mobilePortalRoutes),
    ...(isPC ? boardRoutes : mobileBoardRoutes),
    ...authRoutes
  ];

  return routes;
};
